import { render, staticRenderFns } from "./bimmake.vue?vue&type=template&id=01c526b8&scoped=true"
import script from "./bimmake.vue?vue&type=script&lang=js"
export * from "./bimmake.vue?vue&type=script&lang=js"
import style0 from "./bimmake.vue?vue&type=style&index=0&id=01c526b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c526b8",
  null
  
)

export default component.exports